import { type Component, provide } from 'vue'
import IntroductionContent from '@/features/interface/demande/capp/steps/introduction/IntroductionStep.vue'
import EmployeurContent from '@/features/interface/demande/capp/steps/employeur/EmployeurStep.vue'
import FormationContent from '@/features/interface/demande/capp/steps/formation/FormationStep.vue'
import SyntheseContent from '@/features/interface/demande/capp/steps/synthese/SyntheseStep.vue'
import DocumentsContent from '@/features/interface/demande/capp/steps/documents/DocumentsStep.vue'
import type { ErreurSummaryConfiguration } from '@/features/application/erreur-summary'
import ApprentiContent from '@/features/interface/demande/capp/steps/apprenti/ApprentiStep.vue'
import ContratContent from '@/features/interface/demande/capp/steps/contrat/ContratStep.vue'
import type { ContratApprentissageDTO } from '@/features/api/extranet/dto/Demande/CAPP'
import { useDemandeCAPPStore } from '@/features/interface/demande/capp/useDemandeCAPPStore.ts'
import type { SetupDemande } from '@/features/interface/demande/shared/components/DemandeContent/DemandeContent.types.ts'
import { useDemandeCappActions } from '@/features/interface/demande/capp/useDemandeCAPPActions.ts'
import { CAPP_ACTIONS } from '@/features/interface/demande/capp/useDemandeCAPPActions'

type TabKey = 'Introduction' | 'Employeur' | 'Apprenti' | 'Contrat' | 'Formation' | 'Synthèse' | 'Documents'

const TABS_VUES: Record<TabKey, Component> = {
  Introduction: IntroductionContent,
  Employeur: EmployeurContent,
  Apprenti: ApprentiContent,
  Contrat: ContratContent,
  Formation: FormationContent,
  Synthèse: SyntheseContent,
  Documents: DocumentsContent,
} as const

const TABS_ERR_CONFIG: ErreurSummaryConfiguration<ContratApprentissageDTO> = {
  Introduction: { include: (state) => [state.validationNotice] },
  Employeur: { includeDeep: (state) => [state.employeur] },
  Apprenti: { includeDeep: (state) => [state.apprenti, state.representantLegal, state.tutorat] },
  Contrat: { includeDeep: (state) => [state.contrat, state.remuneration] },
  Formation: { includeDeep: (state) => [state.formation] },
  Synthèse: {
    include: (state) => [state.lieuSignature, state.commentaire, state.acceptationCg, state.attestationSurHonneur],
  },
  Documents: {
    includeDeep: (state) => [state.fichiers],
    include: (state) => [state.attestationPiecesJustificatives],
  },
}

export const SetupDemandeCAPP: SetupDemande<'MODEL_CAPP', TabKey> = {
  useStore: useDemandeCAPPStore,
  injectActions: () => {
    const actions = useDemandeCappActions()
    provide(CAPP_ACTIONS, actions)
    return actions
  },
  tabFirst: 'Introduction',
  tabsVue: TABS_VUES,
  tabsErrorConfig: () => TABS_ERR_CONFIG,
} as const
